import React from "react";
import { string, shape, object, array, oneOfType, number, func } from "prop-types";
import classNames from "classnames/bind";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../sharedComponents/Card";
import * as styles from "./Card.module.scss";

const cx = classNames.bind(styles);

const GroupsHP = ({
	data: {
		to,
		target,
		title,
		subHeader,
		image: { fixed, fluid, source, alt, src },
	},
	onClick,
	index,
}) => (
	<Card to={to} target={target} className={cx("panel")} onClick={onClick} index={index}>
		<Card.Header className={cx("heading", "rockHeading")}>
			{title}
			<div className={cx("subHeader")}>{subHeader}</div>
		</Card.Header>
		<Card.Image zoomable fluid={fluid} fixed={fixed} source={source} src={src} alt={alt} />
	</Card>
);
GroupsHP.propTypes = {
	data: shape({
		to: string,
		target: string,
		title: string,
		subHeader: string,
		image: shape({
			fluid: oneOfType([object, array]),
			fixed: oneOfType([object, array]),
			source: shape({
				src: string,
				srcSet: string,
				sizes: string,
			}),
			alt: string,
			src: string,
		}),
	}).isRequired,
	/**
	 * This will only work if `data` prop don't have `to`
	 */
	onClick: func,
	/**
	 * This should be index if we are creating this component in loop, required by accessibility.
	 */
	index: number,
};
GroupsHP.defaultProps = {
	onClick: null,
	index: 0,
};

export default GroupsHP;
export { GroupsHP };
